export default __webpack_public_path__ + "static/media/checkListOperative.80b1b6a3.png";